<template>
  <div class="products-list-page">
    <v-card class="products-card" elevation="1">
      <HeaderTableTabs :currentTab.sync="currentTab" :tabs="tabs" />
      <Resource
        :resourceType="resourceType"
        :document="document"
        :countt="parseInt(countt)"
        :filter-fields="filter"
        :filter-data="filterData"
        :filter-callback="setFilterData"
        :searchable="searchableField"
        :columns="columns"
        :update-router-callback="getUpdateRouterData"
        :callback-action="getAction"
        :callback-selection="getIds"
        :actionItems="items"
        :routeName="updateRouteName"
        @closeClicked="closeClicked"
        @getType="getType"
        class="px-4 pt-4 pb-2"
      />
      <v-divider />
      <div class="pagination-bar d-flex align-center justify-space-between px-4 py-3 flex-wrap" style="gap: 12px">
        <div class="d-flex align-center" style="gap: 12px">
          <limit-page :callback="setLimit" :page.sync="page" />
          <span v-if="countt" class="pagination-info"> Showing page {{ page }} • {{ countt }} products </span>
        </div>
        <pagination :length="1000000000000" :visible="0" :page.sync="page"></pagination>
      </div>
    </v-card>
    <v-dialog persistent v-model="showModalAddTagsProduct" width="700" style="transform-origin: center top">
      <v-card relative>
        <!-- Title -->
        <v-card-title class="headline"
          >{{ action === 'add-tags' ? ' Add tags' : 'Remove tags' }}
          {{ this.selectAll === 'all' ? productQuantity : ids.length }} products.
        </v-card-title>
        <!-- Close icon -->
        <div class="close-icon" @click="closeShowModalAddTagsProduct">
          <v-icon>fas fa-times</v-icon>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row no-gutters d-flex justify="center">
          <v-col cols="11">
            <h3 class="fz-15">Tags</h3>
            <v-combobox
              v-model.trim="tags"
              hide-selected
              multiple
              persistent-hint
              :delimiters="delimiters"
              small-chips
              placeholder="Enter tags"
              hide-details
              append-icon=""
              @change="onChangeTag"
            >
              <template v-slot:selection="data">
                <v-chip
                  close
                  small
                  label
                  :key="data.item"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-card-subtitle class="pl-8 pt-3 pb-2">
          Select existing tags:
        </v-card-subtitle>
        <v-chip-group column class="group-tags">
          <v-chip small v-for="(item, ind) in listTags" :key="ind" @click="pushTags(item)">
            {{ item }}
          </v-chip>
        </v-chip-group>
        <!-- <div v-for="">
          <v-chip>111</v-chip>
        </div>
         -->
        <v-divider class="my-3"></v-divider>
        <!-- Footer -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="closeShowModalAddTagsProduct"> Close </v-btn>
          <v-btn :loading="isLoadingButton" color="primary" @click="onUpdateBulk"
            >{{ action === 'add-tags' ? ' Add tags' : 'Remove tags' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showModalSelectCollection" width="700" style="transform-origin: center top">
      <v-card relative>
        <!-- Title -->
        <v-card-title class="headline">
          {{ action === 'add-collection' ? 'Add collection' : 'Remove collection' }} for
          {{ this.selectAll === 'all' ? productQuantity : ids.length }} products.
        </v-card-title>
        <v-row no-gutters d-flex justify="center">
          <v-col cols="11">
            <v-text-field autofocus class="px-4" v-model="keySearchCollection"></v-text-field>
          </v-col>
        </v-row>

        <!-- Close icon -->
        <div class="close-icon" @click="closeShowModalSelectCollection">
          <v-icon>fas fa-times</v-icon>
        </div>
        <v-divider class="mb-3"></v-divider>
        <div class="list-product" v-if="!isLoadingCollection">
          <!-- <div class="py-3 my-2">
            <v-divider></v-divider>
          </div> -->
          <div v-for="(i, k) in collectionSelectList" :key="i._id" class="px-4 px-12">
            <div class="d-flex align-center">
              <v-checkbox v-model="idsCollection" :value="i._id" class="mr-4"></v-checkbox>
              <v-avatar tile size="40">
                <img
                  :src="i.images && i.image.src ? imageHelpers.url(i.image.src) : '@/assets/images/no-image.png'"
                  alt=""
                />
              </v-avatar>
              <span class="ml-3 link-add">{{ i.title }}</span>
            </div>

            <v-divider v-if="k + 1 < collectionSelectList.length" class="mt-2"></v-divider>
          </div>
          <div v-if="!isLoadingCollection && collectionSelectList.length === 0" class="d-flex flex-column align-center">
            <!-- <img  :src="imageFake.Emty" alt="" srcset="" /> -->
            <empty />
            <!-- <div>No Collection</div> -->
          </div>
        </div>
        <div style="width: 100%" v-else class="list-product d-flex justify-center align-center my-3">
          <!-- <page-loader /> -->
        </div>

        <v-divider class="mb-3"></v-divider>
        <!-- Footer -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="closeShowModalSelectCollection"> Close </v-btn>
          <v-btn :loading="isLoadingButton" color="primary" @click="onUpdateBulk"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showModalDelete" width="500" style="transform-origin: center top">
      <v-card relative>
        <!-- Title -->
        <v-card-title class="headline">
          {{ 'Delete' }} {{ this.selectAll === 'all' ? productQuantity : ids.length }} products?.
        </v-card-title>
        <div class="close-icon" @click="showModalDelete = false">
          <v-icon>fas fa-times</v-icon>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-card-text class="">
          Are you sure you want to delete {{ this.selectAll === 'all' ? productQuantity : ids.length }} products. This
          action cannot be reversed.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="showModalDelete = false"> Cancel </v-btn>
          <v-btn :loading="isLoadingButton" color="error" @click="onSubmitDelete"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showModelAvailable" width="500">
      <v-card>
        <v-card-title
          >Make {{ this.selectAll === 'all' ? productQuantity : ids.length }} products
          {{ action === 'make-available' ? 'available ' : 'unavailable' }}</v-card-title
        >
        <div class="close-icon" @click="showModelAvailable = false"><v-icon>fas fa-times</v-icon></div>
        <v-card-text
          >Are you sure you want to {{ action === 'make-available' ? 'enable ' : 'disable' }}
          {{ this.selectAll === 'all' ? productQuantity : ids.length }} products?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showModelAvailable = false">Cancel</v-btn>
          <v-btn color="primary" @click="onUpdateBulk"
            >Make products {{ action === 'make-available' ? 'available ' : 'unavailable' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UpContentAdsDialog v-model="showModalUpContentAds" :productId="upContentAdsProductId" />
  </div>
</template>

<script>
import { collectionApi } from '@/apis/collection';
import { productApi } from '@/apis/product';
import Resource from '@/components/Resources';
import filter from '@/const/filters/product-filter';
import { imageFake } from '@/const/image';
import resourceListMixin from '@/mixins/resource-list';
import { FETCH_STORES } from '@/store/actions.type';
import { mapGetters } from 'vuex';
import Empty from '../../../../components/Empty.vue';
import UpContentAdsDialog from './UpContentAdsDialog.vue';

export default {
  components: { Resource, Empty, UpContentAdsDialog },
  mixins: [resourceListMixin],
  data() {
    return {
      productQuantity: 0,
      selectAll: '',
      idSelected: '',
      listTags: '',
      delimiters: [','],
      items: [
        // { title: 'Make products available', action: 'make-available' },
        { title: 'Make products unavailable', action: 'make-unavailable' },
        { title: 'Edit Product', action: 'bulk-edit' },
        // { title: 'Delete selected products', action: 'remove-product' },
        // { title: 'Add tags', action: 'add-tags' },
        // { title: 'Remove tags', action: 'remove-tags' },
        // { title: 'Add Collection', action: 'add-collection' },
        // { title: 'Remove Collection', action: 'remove-collection' },
      ],
      imageFake,
      showModalDelete: false,
      collectionSelectList: [],
      showModalSelectCollection: false,
      idsCollection: [],
      keySearchCollection: '',
      isLoadingButton: false,
      tags: [],
      showModalAddTagsProduct: false,
      showModelAvailable: false,
      ids: [],
      available: '',
      resourceType: 'products',
      length: 1,
      action: '',
      count: 1,
      tabs: [
        // { name: 'All', key: '' },
        { name: 'Available products', key: 'published' },
        // { name: 'Unavailable products', key: 'unpublished' },
      ],
      testVuex: null,
      columns: {
        Selectable: {
          blankLabel: true,
          kind: 'selectable',
          width: 1,
        },
        Title: {
          // blankLabel: true,
          kind: 'viewProduct',
          field: 'title',
        },
        // Vendor: {
        //   kind: 'text',
        //   field: 'vendor',
        //   style: {
        //     textAlign: 'end',
        //   },
        // },
        BaseCost: {
          kind: 'price',
          field: 'baseCost',
          style: {
            textAlign: 'end',
          },
        },
        'Selling Price': {
          kind: 'price',
          field: 'sellingPrice',
          style: {
            textAlign: 'end',
          },
        },
        // '% Cost': {
        //   kind: 'percent',
        //   field: 'costPercent',
        //   style: {
        //     textAlign: 'end',
        //   },
        // },
        // Profit: {
        //   kind: 'text',
        //   field: 'profit',
        //   style: {
        //     textAlign: 'end',
        //   },
        // },
        // 'Product Type': {
        //   field: 'productType',
        //   kind: 'title',
        // },
        // Vendor: {
        //   field: 'vendor',
        //   kind: 'title',
        // },
        // Actions: {
        //   kind: 'actions',
        //    blankLabel: true,
        // },
      },
      // searchableField: 'with title',
      sortable: [],
      filter,
      updateRouteName: 'website.products.update',
      isLoadingCollection: false,
      queryDetail: '',
      showModalUpContentAds: false,
      upContentAdsProductId: null,
    };
  },
  async created() {
    await this.getCollection();
    // await this.getTags();
    await this.$store.dispatch(FETCH_STORES);
    // Add special items for specific user if needed (on created)
    this.applySpecialUserOptions();
  },
  watch: {
    selectAll() {
      if (this.selectAll === 'all') {
        this.getAllTag();
      } else {
        this.getTags();
      }
    },
    idSelected() {
      this.getTags();
    },
    keySearchCollection() {
      if (this.executor) {
        clearTimeout(this.executor);
        this.executor = null;
      }
      this.executor = setTimeout(async () => {
        await this.getCollection();
      }, 300);
    },
    page() {
      console.log(this.page);
    },
    user() {
      this.applySpecialUserOptions();
    },
  },
  computed: {
    ...mapGetters(['user', 'stores']),
    storeURL() {
      return 'https://' + this.$store.state.auth.accountInfo.rDomain;
    },
  },
  methods: {
    // Bật các tuỳ chọn riêng cho tài khoản đặc biệt
    applySpecialUserOptions() {
      if (!this.user?.email?.includes('abcabc@dropnoxe.com')) return;
      if (!this.items.some(i => i.action === 'make-available')) {
        this.items.push({ title: 'Make products available', action: 'make-available' });
      }
      if (!this.items.some(i => i.action === 'make-unavailable')) {
        this.items.push({ title: 'Make products unavailable', action: 'make-unavailable' });
      }
      if (!this.items.some(i => i.action === 'add-collection')) {
        this.items.push({ title: 'Add Collection', action: 'add-collection' });
      }
      if (!this.tabs.some(t => t.key === 'unpublished')) {
        this.tabs.push({ name: 'Unavailable products', key: 'unpublished' });
      }
    },
    // lấy tag của tất cả product khi chọn select all
    async getAllTag() {
      let params = {
        // limit: 50,
      };
      let res = await productApi.getProductTags(params);
      // this.listTags = res.data.tags;
      this.listTags = [];
    },
    getType(data) {
      this.selectAll = data;
    },
    // backToPage1() {
    //   this.page = 1;
    // },
    pushTags(i) {
      if (this.tags.findIndex(a => a == i) == -1) {
        this.tags.push(i);
        console.log(this.tags);
      }
    },
    onChangeTag(e) {
      this.tags = e.filter(item => item.trim() !== '');
    },
    closeClicked(data) {
      this.filter.forEach(item => {
        if (item.field == data) {
          item.model = '';
        }
      });
    },
    async getTags() {
      if (this.selectAll != 'all') {
        try {
          let params = `?ids=${this.idSelected.join(',')}`;
          let res = await productApi.getTags(params);
          // this.listTags = res.data.tags;
          this.listTags = [];
        } catch (error) {}
      }
    },
    async getCollection() {
      try {
        let params = {
          page: 1,
          limit: 100,
          search: this.keySearchCollection,
        };
        this.isLoadingCollection = true;
        let res = await collectionApi.get(params);
        this.collectionSelectList = res.data.collections.filter(item => {
          return item.collectionType === 'normal';
        });
        this.$forceUpdate();
        this.isLoadingCollection = false;
      } catch (error) {}
    },
    getIds(ids) {
      this.idSelected = ids;
      this.$parent.ids = ids;
      // this.getTags();
      // console.log(this.idSelected);
    },
    async onSubmitDelete() {
      try {
        this.isLoadingButton = true;
        let query = this.$route.query;
        console.log(query);
        let convertData = {
          data: {},
          ids: this.ids,
          type: this.selectAll,
        };
        convertData.query = query;
        let tab;
        if (this.$route.query.tab == 'published') {
          tab = 'false';
        }
        if (this.$route.query.tab == 'unpublished') {
          tab = 'true';
        }
        if (this.selectAll !== 'all') {
          await productApi.remove(`?ids=${this.ids.join(',')}`);
        }
        if (this.selectAll === 'all' && query._query) {
          convertData.query = query;
        }
        convertData.data.deleted = true;
        await productApi.updateBulk(convertData, this.searchString, tab, this.selectAll);
        this.isLoading = true;
        this.showModalDelete = false;

        await this.getResources();
        this.isLoading = false;
      } catch (error) {
        //empty
      }
      this.showModalDelete = false;
      this.isLoadingButton = false;
    },
    closeShowModalAddTagsProduct() {
      this.showModalAddTagsProduct = false;
      this.tags = [];
    },
    closeShowModalSelectCollection() {
      this.showModalSelectCollection = false;
      this.keySearchCollection = '';
      this.idsCollection = [];
    },
    async onUpdateBulk() {
      try {
        let convertData = {
          data: {},
          ids: this.ids,
          type: this.selectAll,
        };
        let tab = this.$route.query.tab;
        console.log(tab);
        this.isLoadingButton = true;
        // cho vào settimeout để hàm này chạy sau khi @input ở combobox, để this.tags != ''
        setTimeout(async () => {
          let query = this.$route.query;
          console.log(query);
          convertData.query = query;
          if (this.selectAll === 'all' && query._query) {
            console.log(convertData.query);
          }
          if (this.action === 'add-tags') {
            convertData.data.add_tags = this.tags;
          }
          if (this.action === 'remove-tags') {
            convertData.data.remove_tags = this.tags;
          }
          if (this.action === 'add-collection') {
            convertData.data.add_collections = this.idsCollection;
          }
          if (this.action === 'remove-collection') {
            convertData.data.remove_collections = this.idsCollection;
          }
          if (this.action === 'make-available') {
            convertData.data.published = true;
          }
          if (this.action === 'make-unavailable') {
            convertData.data.published = false;
          }
          console.log('convertData', convertData);
          await productApi.updateBulk(convertData, this.searchString, tab, this.selectAll);

          this.showModalAddTagsProduct = false;
          this.showModalSelectCollection = false;
          this.showModelAvailable = false;
          this.idsCollection = [];
          this.tags = [];
          await this.getResources();
        }, 0);
      } catch (error) {
        console.log('error', error);
        //empty
      }
      this.isLoadingButton = false;
    },
    getAction(action, ids) {
      if (action.action === 'view-offer-discount') {
        this.$router.push({
          name: 'website.apps.quantity.update',
          params: { id: ids[0] },
        });
        return;
      }
      this.ids = ids;
      this.action = action.action;
      if (action.action === 'bulk-edit') {
        this.$router.push({
          name: 'website.products.bulkEdit',
          query: {
            ids: ids.join(','),
          },
        });
      }
      if (action.action === 'add-tags' || action.action === 'remove-tags') {
        this.showModalAddTagsProduct = true;
        this.tags = [];
      }
      if (action.action === 'add-collection' || action.action === 'remove-collection') {
        this.showModalSelectCollection = true;
      }
      if (action.action === 'make-available' || action.action === 'make-unavailable') {
        this.showModelAvailable = true;
      }
      if (action.action === 'remove-product') {
        this.showModalDelete = true;
      }
      if (action.action === 'up-content-ads') {
        this.upContentAdsProductId = ids;
        this.showModalUpContentAds = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.products-list-page {
  .page-header {
    .page-title {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.2;
      margin: 0;
      color: var(--v-on-surface-base, #1a1f36);
    }
    .page-subtitle {
      font-size: 13px;
      color: #6b7280;
      margin-top: 2px;
    }
  }

  .products-card {
    border-radius: 12px;
    overflow: hidden;
  }

  .pagination-bar {
    background: #fafbfc;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

    .pagination-info {
      font-size: 13px;
      color: #6b7280;
    }

    ::v-deep .v-pagination__navigation,
    ::v-deep .v-pagination__item {
      box-shadow: none;
      border: 1px solid #e5e7eb;
      background: #fff;
    }
    ::v-deep .v-pagination__item--active {
      background: var(--v-primary-base) !important;
      color: #fff !important;
    }
  }
}
</style>
